import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'
import {PATH} from '@/constants'
import RequesterBuilder from '@/assets/plugins/mps-common/network/requester-builder'
import {ON_LOADING_OVERLAY_CLOSE_REQUESTED, ON_LOADING_OVERLAY_OPEN_REQUESTED,} from '@/framework/listeners/listeners'
import {vm} from '@/main'
import {translationManager} from '@/assets/plugins/mps-common/translation/translation-manager'
import now from '@/assets/plugins/mps-common/time/now'
import utilManager from '@/assets/plugins/mps-common/util/util-manager'
import userManager from '@/assets/plugins/mps-common/user/user-manager'
import {dateHelper} from '@/assets/plugins/mps-common/time/date-helper'
import {isEmpty} from '@/assets/plugins/mps-common/expansions/condition'
import ExcelHelper from "@/framework/excel/ExcelHelper";

class ExcelDownloadMembershipList {
  /**
   * 헤더 그룹
   * 헤더의 윗 행으로, 범위 내 셀을 병합하고 그룹명을 표시합니다.
   */
  _headerGroups = [
    {
      groupName: translationManager.translate('설정 정보'),
      startLetter: 'F',
      endLetter: 'L',
    },
    {
      groupName: translationManager.translate('대표자'),
      startLetter: 'M',
      endLetter: 'O',
    },
    {
      groupName: translationManager.translate('담당자'),
      startLetter: 'P',
      endLetter: 'R',
    },
    {
      groupName: translationManager.translate('모니터링'),
      startLetter: 'T',
      endLetter: 'V',
    },
    {
      groupName: translationManager.translate('임대업체추가정보'),
      startLetter: 'AB',
      endLetter: 'AM',
    },
  ]

  _headers = [
    {
      text: translationManager.translate('업체코드'),
      value: 'rentalcompanyId',
      excelWidth: 10,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('업체명'),
      value: 'rentalcompanyName',
      excelWidth: 30,
      excelAlign: 'left',
    },
    {
      text: translationManager.translate('사업자번호'),
      value: 'businessNo',
      excelWidth: 15,
      excelAlign: 'left',
    },
    {
      text: translationManager.translate('그룹 목록'),
      value: 'groupNamesText',
      excelWidth: 15,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('승인'),
      value: 'approvedYn',
      excelWidth: 9,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('사용여부'),
      value: 'useYn',
      excelWidth: 8,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('월사용량'),
      value: 'useAutoUsage',
      excelWidth: 8,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('매출'),
      value: 'useAutoSales',
      excelWidth: 8,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('CMS'),
      value: 'useAutoCms',
      excelWidth: 8,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('TAX'),
      value: 'useAutoTax',
      excelWidth: 8,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('접속 허용'),
      value: 'loginApproveYn',
      excelWidth: 8,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('업무지원 로그인 기한'),
      value: 'csExpiredDatetime',
      excelWidth: 18,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('성명'),
      value: 'ceoFullname',
      excelWidth: 14,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('전화번호'),
      value: 'ceoMobileno',
      excelWidth: 15,
      excelAlign: 'center',
      wrapText: true,
    },
    {
      text: translationManager.translate('이메일'),
      value: 'ceoEmail',
      excelWidth: 25,
      excelAlign: 'left',
    },
    {
      text: translationManager.translate('성명'),
      value: 'userFullname',
      excelWidth: 12,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('전화번호'),
      value: 'userMobileno',
      excelWidth: 20,
      excelAlign: 'center',
      wrapText: true,
    },
    {
      text: translationManager.translate('이메일'),
      value: 'userEmail',
      excelWidth: 25,
      excelAlign: 'left',
    },
    {
      text: translationManager.translate('주소'),
      value: 'fullAddress',
      excelWidth: 50,
      excelAlign: 'left',
      wrapText: true,
    },
    {
      text: translationManager.translate('device'),
      value: 'collectedDV',
      excelWidth: 10,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('agent'),
      value: 'collectedPC',
      excelWidth: 10,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('printer'),
      value: 'monitorngPrinterCnt',
      excelWidth: 10,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('CMS'),
      value: 'cms',
      excelWidth: 10,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('국가'),
      value: 'countryCodeName',
      excelWidth: 20,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('영업담당자 메모'),
      value: 'memo',
      excelWidth: 25,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('모니터링주기설정'),
      value: 'agentInterval',
      excelWidth: 15,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('거래처 마이그레이션'),
      value: 'fileCount',
      excelWidth: 18,
      excelAlign: 'center',
    },
    // {
    //   text: translationManager.translate('매출 확인'),
    //   value: 'sales',
    //   excelWidth: 25,
    //   excelAlign: 'center',
    //
    // },
    {
      text: translationManager.translate('관리코드'),
      value: 'salesCustomCode',
      excelWidth: 15,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('실사용 여부'),
      value: 'actualYn',
      excelWidth: 10,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('무상 기간 종료일'),
      value: 'freeUseEndDate',
      excelWidth: 15,
      excelAlign: 'center',
    },

    {
      text: translationManager.translate('최초 계약일'),
      value: 'initContractDate',
      excelWidth: 15,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('계약 시작일'),
      value: 'curStartContractDate',
      excelWidth: 15,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('청구 종료일'),
      value: 'curEndContractDate',
      excelWidth: 15,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('당 계약 종료일'),
      value: 'toBeRenewContractDate',
      excelWidth: 15,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('계약 금액'),
      value: 'contractAmount',
      excelWidth: 18,
      excelAlign: 'right',
    },
    {
      text: translationManager.translate('최근 로그인'),
      value: 'lastLoginDatetime',
      excelWidth: 18,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('실 담당자 명'),
      value: 'connectorName',
      excelWidth: 12,
      excelAlign: 'center',
    },
    {
      text: translationManager.translate('실 담당자 연락처'),
      value: 'connectorMobile',
      excelWidth: 15,
      excelAlign: 'left',
    },
    {
      text: translationManager.translate('비고'),
      value: 'remark01',
      excelWidth: 25,
      excelAlign: 'left',
    },
  ]

  _searchOptions

  constructor() {}

  get searchOptions() {
    return this._searchOptions
  }

  set searchOptions(searchOptions) {
    this._searchOptions = searchOptions
  }

  get headers() {
    return this._headers
  }

  set headers(headers) {
    this._headers = headers
  }

  get worksheetColumnHeaders() {
    return this.headers
        .filter((e) => (e.exclude ? !e.exclude() : true))
        .map((e) => {
          return {
            header: e.text,
            key: e.value,
            width: e.excelWidth,
            alignment: {
              vertical: 'middle',
              horizontal: e.excelAlign,
              wrapText: e.wrapText,
            },
          }
        })
  }

  get headerGroups() {
    return this._headerGroups
  }

  createAndFillWorkbook(items) {
    const workbook = new ExcelJS.Workbook()
    workbook.creator = userManager.user.displayName
    workbook.lastModifiedBy = userManager.user.displayName
    workbook.created = new Date()
    workbook.modified = new Date()
    workbook.lastPrinted = new Date()
    workbook.properties.date1904 = true
    workbook.calcProperties.fullCalcOnLoad = true
    workbook.views = [
      {
        x: 0,
        y: 0,
        width: 1000,
        height: 2000,
        firstSheet: 0,
        activeTab: 0,
        visibility: 'visible',
      },
    ]

    // format
    items.forEach((item) => {
      item.forEach((e) => {
        // 그룹 목록
        e.groupNamesText = e.groupNamesText || '-'

        // 승인
        e.approvedYn = e.approvedYn === 'Y' ? '승인 완료' : '미승인'
        // 업무지원 로그인 기한
        e.csExpiredDatetime = e.csExpiredDatetime ? dateHelper.formatDateTime(e.csExpiredDatetime) : '-'

        // ceo 성명
        e.ceoFullname = e.ceoFullname || '-'
        // ceo 전화번호
        // e.ceoMobileno = e.ceoMobileno ? 'M: ' + e.ceoMobileno : '-'
        e.ceoMobileno = (e.ceoTelno ? `T: ${e.ceoTelno}\n` : '')
            + (e.ceoMobileno ? 'M: ' + e.ceoMobileno : '')
        // ceo 이메일
        e.ceoEmail = e.ceoEmail || '-'

        // 담당자 성명
        e.userFullname = e.userFullname || '-'
        // 담당자 전화번호
        e.userMobileno = (e.userTelno ? `T: ${e.userTelno}\n` : '')
          + (e.userMobileno ? 'M: ' + e.userMobileno : '')
        // 담당자 이메일
        e.userEmail = e.userEmail || '-'

        // 주소
        e.fullAddress = `${e.address || ''}\n${e.addressDetail || ''}`

        // 모니터링 device
        e.collectedDV = e.collectedDV || '-'
        // 모니터링 agent
        e.collectedPC = e.collectedPC || '-'
        // 모니터링 printer
        e.monitorngPrinterCnt = e.monitorngPrinterCnt || '-'

        // CMS
        e.cms = e.cms || '-'
        // 국가
        e.countryCodeName = e.countryCodeName || '-'
        // 영업담당자 메모
        e.memo = e.memo || '-'
        // 모니터링주기설정
        e.agentInterval = e.agentInterval || '-'
        // 거래처 마이그레이션
        e.fileCount = e.fileCount || '-'
        // 관리코드
        e.salesCustomCode = e.salesCustomCode || '-'

        // 무상 기간 종료일
        e.freeUseEndDate = e.freeUseEndDate || '-'
        // 최초 계약일
        e.initContractDate = e.initContractDate || '-'
        // 계약 시작일
        e.curStartContractDate = e.curStartContractDate || '-'
        // 청구 종료일
        e.curEndContractDate = e.curEndContractDate || '-'
        // 당 계약 종료일
        e.toBeRenewContractDate = e.toBeRenewContractDate || '-'
        // 계약 금액
        e.contractAmount = e.contractAmount || 0
        // 최근 로그인
        e.lastLoginDatetime = e.lastLoginDatetime ? dateHelper.formatDateTime(e.lastLoginDatetime) : '-'
        // 실 담당자 명
        e.connectorName = e.connectorName || '-'
        // 실 담당자 연락처
        e.connectorMobile = e.connectorMobile || '-'
        // 비고
        e.remark01 = e.remark01 || '-'
      })
    })

    items.forEach((obj, index) => {
      this.addWorkSheetAndFillRow(
          workbook,
          index * 1000 + 1 + '~' + (index * 1000 + 1000),
          obj
      )
    })

    return workbook
  }

  addWorkSheetAndFillRow(workbook, name, items) {
    const excelHelper = new ExcelHelper()
    // 헤더 그룹 정보
    const headerGroups = this.headerGroups
    const groupRowIdx = 3
    // 헤더 정보
    const worksheetColumnHeaders = this.worksheetColumnHeaders
    const headerRowIdx = groupRowIdx + 1

    // create new sheet with properties
    const worksheet = workbook.addWorksheet(name, {
      pageSetup: { paperSize: 9 },
      properties: {
        tabColor: { argb: 'FF00FF00' },
      },
      views: [{ state: 'frozen', ySplit: headerRowIdx }, { zoomScale: 85 }],
    })

    worksheet.properties.tabColor = '#fff'

    worksheet.columns = worksheetColumnHeaders

    const lastLetter = this.getExcelColumnByCount(worksheetColumnHeaders.length)
    // 헤더(행) 이 3행으로 옮겨집니다.
    worksheet.insertRow(1, {})
    worksheet.insertRow(1, {})
    // 3행의 데이터를 복사하여 4행을 만듭니다.
    // 결과 : 3행 => 그룹(행), 4행 => 헤더(행)
    worksheet.duplicateRow(groupRowIdx, 1, true)

    worksheet.mergeCells(`A1:${lastLetter}1`)
    worksheet.mergeCells(`A2:${lastLetter}2`)

    // 출력날짜 등 표시
    const firstRow = worksheet.getRow(1)
    firstRow.height = 20
    const secondRow = worksheet.getRow(2)
    secondRow.height = 60

    const firstCell = worksheet.getCell('A1') // 현재 A1은 merge 되어 하나의 로우가 됨
    firstCell.value =
        translationManager.translate('출력 날짜') +
        ': ' +
        now().toISODate() +
        '  '
    firstCell.alignment = {
      vertical: 'middle',
      horizontal: 'right',
    }
    firstCell.font = {
      color: { argb: '00000000' },
      size: 12,
      bold: true,
    }

    const secondCell = worksheet.getCell('A2') // 현재 A2은 merge 되어 하나의 로우가 됨
    secondCell.value = translationManager.translate('임대업체 관리')
    secondCell.alignment = {
      vertical: 'middle',
      horizontal: 'center',
    }

    secondCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '000070c0' },
      bgColor: { argb: '000070c0' },
    }

    secondCell.font = {
      color: { argb: 'FFFFFFFF' },
      size: 16,
      bold: true,
    }

    if (isEmpty(items)) return
    // 데이터 행 추가
    worksheet.addRows(items)

    // 헤더 그룹 스타일 디자인
    const headerGroupRow = worksheet.getRow(groupRowIdx)
    headerGroupRow.height = 30
    headerGroups.forEach((groupInfo) => {
      const cell = worksheet.getCell(groupInfo.startLetter + groupRowIdx) // 병합 첫 셀 정보
      const endCell = groupInfo.endLetter + groupRowIdx // 병합 마지막 셀 정보

      // 그룹에 헤더 스타일을 적용합니다.
      this.setHeaderCellStyle(cell, excelHelper)
      // 그룹명 적용
      cell.value = groupInfo.groupName

      // 같은 그룹 셀끼리 병합
      worksheet.mergeCells(`${cell.$col$row}:${endCell}`)
    })


    // 헤더 스타일 디자인
    let columnHeaderLetter = 'A' // 컬럼 헤더는 A부터 시작
    const headerRow = worksheet.getRow(headerRowIdx)
    headerRow.height = 30
    worksheetColumnHeaders.forEach((header) => {
      const groupCell = worksheet.getCell(columnHeaderLetter + groupRowIdx)
      const cell = worksheet.getCell(columnHeaderLetter + headerRowIdx)
      // 셀에 헤더 스타일을 적용합니다.
      this.setHeaderCellStyle(cell, excelHelper)

      // 그룹 셀과 헤더 셀의 값이 같으면 병합합니다.
      if (groupCell && cell.value === groupCell.value) {
        worksheet.mergeCells(`${cell.$col$row}:${groupCell.$col$row}`)
      }

      columnHeaderLetter = this.getExcelNextChar(columnHeaderLetter)
    })

    // 셀 스타일 디자인
    for (let i = 0; i < items.length; i++) {
      const adjustIndex = i + 5
      const row = worksheet.getRow(adjustIndex)
      row.height = 40
      let letter = 'A' // 컬럼 헤더는 A부터 시작
      worksheetColumnHeaders.forEach((header) => {
        const cell = worksheet.getCell(letter + adjustIndex)

        // 주소 컬럼 alignment 설정
        // if (cell._column._key === 'fullAddress') {
        //   cell.alignment = {
        //     horizontal: 'left',
        //     vertical: 'bottom',
        //     wrapText: true,
        //   }
        // }

        cell.border = {
          top: { style: 'thin', color: { argb: '00dddddd' } },
          left: { style: 'thin', color: { argb: '00dddddd' } },
          right: { style: 'thin', color: { argb: '00dddddd' } },
          bottom: { style: 'thin', color: { argb: '00dddddd' } },
        }
        cell.fill = excelHelper.getRowColor()
        cell.alignment = header.alignment
        letter = this.getExcelNextChar(letter)//utilManager.nextChar(letter)
      })

      // 행이 바뀌면 행 색상을 변경하여 준다.
      excelHelper.increaseRowColor()
    }

    const totalRowLength = items.length + headerRowIdx
    // 전체적인 틀에 진한 보더를 준다
    for (let i = 1; i <= totalRowLength; i++) {
      let letter = 'A'
      for (let j = 0; j < worksheetColumnHeaders.length; j++) {
        if (j === 0) {
          const cell = worksheet.getCell(letter + i)
          cell.border = { ...cell.border, left: { style: 'thin' } }
        }
        if (i === 1) {
          const cell = worksheet.getCell(letter + i)
          cell.border = { ...cell.border, top: { style: 'thin' } }
        }
        if (i === totalRowLength) {
          const cell = worksheet.getCell(letter + i)
          cell.border = { ...cell.border, bottom: { style: 'thin' } }
        }
        if (j === worksheetColumnHeaders.length - 1) {
          const cell = worksheet.getCell(letter + i)
          cell.border = { ...cell.border, right: { style: 'thin' } }
        }
        letter = this.getExcelNextChar(letter)//utilManager.nextChar(letter)
      }
    }
  }

  setHeaderCellStyle(cell, excelHelper) {
    cell.alignment = excelHelper.excelStyle.header.alignment.center
    cell.font = excelHelper.excelStyle.header.font.default
    cell.fill = excelHelper.excelStyle.header.fill.default
    cell.border = excelHelper.excelStyle.cell.border
  }

  async exportToExcel() {
    vm.notifyEvent(ON_LOADING_OVERLAY_OPEN_REQUESTED, {
      text: translationManager.translate(
          '엑셀 다운로드 중입니다. 잠시만 기다려 주십시오.'
      ),
    })
    try {
      const size = 1000
      let pageNumber = 1
      const items = []
      // eslint-disable-next-line no-constant-condition
      while (true) {
        const temp = await this.loadExcelData(size, pageNumber)
        if (Object.keys(temp).length === 0) break
        items.push(temp)
        pageNumber += 1
      }

      if (!!items && items[0]) {
        const workbook = this.createAndFillWorkbook(items)
        const data = await workbook.xlsx.writeBuffer()
        const blob = new Blob([data])
        const filename =
            translationManager.translate('임대업체 관리') +
            '_' +
            now().toISODate() +
            '.xlsx'
        FileSaver.saveAs(blob, filename)
      } else {
        vm.$alert(translationManager.translate('다운로드할 데이터가 없습니다.'))
      }
    } catch (e) {
      console.error(e)
      vm.$alert(translationManager.translate('엑셀 다운로드에 실패하였습니다.'))
    }
    vm.notifyEvent(ON_LOADING_OVERLAY_CLOSE_REQUESTED)
  }

  async loadExcelData(pageSize = 100, pageNumber = 1) {
    const res = await new RequesterBuilder()
        .path(PATH.MEMBERSHIP.LIST)
        .setObject({
          ...this.searchOptions,
          pageNumber,
          pageSize,
        })
        .catch()
        .enqueue()
    return res.data
  }

  getExcelNextChar(column){
    const lastChar = column.slice(-1)
    let nextChar = ''
    // const nextLastChar = utilManager.nextChar(lastChar)
    // if(nextLastChar > 'z'){
    if(lastChar === 'Z'){
      if(column.slice(0,-1) ===''){
        nextChar = 'AA'
      }else{
        nextChar = this.getExcelNextChar(column.slice(0,-1)) + 'A'
      }
    }else{
      nextChar =  column.slice(0,-1) + utilManager.nextChar(lastChar)//column.split(0,-1) + utilManager.nextChar(lastChar)
    }
    return nextChar
    // return utilManager.nextChar(column)
  }
  // agetExcelNextChar(column){
  //   const lastChar = column.slice(-1)
  //   let nextChar = ''
  //   if(lastChar === 'Z'){
  //     if(column.slice(0,-1) ===''){
  //       nextChar = 'A'
  //     }else{
  //       nextChar = this.getExcelNextChar(column.slice(0,-1)) + 'A'
  //     }
  //     console.log('last char is z, and nextChar:',nextChar)
  //   }else{
  //     nextChar = column.slice(0,-1) + getNextChar(lastChar)
  //     console.log(`splited:${column.slice(0,-1)}, next:${getNextChar(lastChar)}`)
  //   }
  //   return nextChar
  //   // return utilManager.nextChar(column)
  // }

  getExcelColumnByCount(count){
    const value = parseInt(count/26)
    const rest = count % 26
    let first = '', second = ''
    if(value){
      first = utilManager.toChar('A',value-1)
    }
    if(rest){
      second = utilManager.toChar('A',rest-1)
    }
    return first + second
  }

}

export default ExcelDownloadMembershipList
